export default type =>
  type ? sessionStorage.setItem("userType", type) : sessionStorage.removeItem("userType");
